(() => {
  const refresh = () => fetch((window.Shopify?.routes?.root || '/') + 'cart.js')
    .then(response => response.json())
    .then(cart => document.querySelectorAll('[data-tr-count]').forEach(element => {
      element.textContent = cart.item_count || '';
      element.hidden = !cart.item_count;
    })).catch(() => {});
  ['cart:add', 'cart:refresh', 'cart:updated', 'shopify:section:load']
    .forEach(event => document.addEventListener(event, refresh));
  window.addEventListener('pageshow', refresh);
  // Symmetry 5.2 uses jQuery AJAX for product and cart interactions.
  if (window.jQuery) {
    window.jQuery(document).on('ajaxSuccess.trilaniCart', (event, xhr, options) => {
      if (/\/cart\/(add|change|update)(\.js)?(?:\?|$)/.test(options.url || '')) refresh();
    });
  }
})();
